import { ENV } from "@vrf/fr-vrf-core";

export const TEMPLATE_FILE_URL =
  "spreadsheet-template/root-component-list-page.xlsx";

export enum RootComponentPageMode {
  ADD_ROOT_COMPONENT = "addRootComponent",
}

export const REQUEST_CD_TYPES = {
  IN_DEF_COMMON_FLAG_TYPE: "in_def_common_flag_type",
};

export const requestCdTypes = Object.values(REQUEST_CD_TYPES);
